import { useEffect, useState } from "react";
import { useLanguage } from "../../context/Language/LanguageContext";
import Dashboard from "./Dashboard";
import SummaryCharts from "./SummaryCharts";

function Summary({ matches, team, selectedGame, selectedTeam }) {
  const [displayScreen, setDisplayScreen] = useState(0);
  const { t } = useLanguage();

  useEffect(() => {}, []);

  const tabClass = (idx) => `tab ${displayScreen === idx ? "tab-active" : ""}`;

  return (
    <>
      <div className="flex-col">
        <div className="tabs tabs-boxed inline-flex mb-2">
          <button className={tabClass(0)} onClick={() => setDisplayScreen(0)}>
            {t("Dashboard")}
          </button>
          {matches.length === 1 ? (
            <button className={tabClass(1)} onClick={() => setDisplayScreen(1)}>
              {t("Charts")}
            </button>
          ) : (
            <></>
          )}
        </div>
        <div className="">
          {displayScreen === 1 ? (
            <SummaryCharts match={matches[0]} />
          ) : (
            <Dashboard
              matches={matches}
              team={team}
              selectedGame={selectedGame}
              selectedTeam={selectedTeam}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Summary;
